<template>
  <swiper
    ref="hoop"
    v-if="carousels"
    class="carousels mx-auto w"
    :options="hooperSettings"
  >
    <swiper-slide
      class="silde-css"
      v-for="slide in carousels"
      :key="slide.id"
      :data-id="slide.id"
    >
      <div
        class="carousels-img relative cursor-pointer w-full"
        :style="'background-image: url(' + slide.image_url + ');'"
      >
        <div class="hooper-font absolute cursor-default">
          <div class="hooper-font-title">{{ slide.title }}</div>
          <div class="hooper-font-content">{{ slide.description }}</div>
        </div>
      </div>
    </swiper-slide>

    <div class="swiper-pagination" slot="pagination"></div>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>

<script>
import link from '@/core/mixins/link'
import { clickedOnCarousel } from '@/core/api'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'carousels-component',
  props: {},
  mixins: [link],
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      hooperSettings: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        // effect: 'fade',
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    carousels() {
      let data = this.$store.getters['CarouselsStore/carousels']
      if (data === false) {
        return false
      }

      return data
    }
  },
  mounted() {
    // swiper loop:true时，复制的dom绑定不上事件，现用js绑定-----begin-----
    let _this = this
    var slides = document.querySelectorAll('.silde-css')
    slides.forEach(item => {
      item.onclick = function() {
        let res = _this.carousels.filter(v => v.id + '' === item.dataset.id)
        if (res && res.length) _this.carouselsLink(res[0])
      }
    })
    // swiper loop:true时，复制的dom绑定不上事件，现用js绑定-----end-----
  },
  methods: {
    async carouselsLink(item) {
      let res = await clickedOnCarousel(item.id, { scope: 'web' })
      // console.log(res.data) // eslint-disable-line no-console
      if (res.status === 200) {
        let data = res.data

        if (data.link_type && data.link_value) {
          let obj = {}
          obj.category = data.link_category

          if (data.link_category && data.link_type === 'article') {
            obj.type = data.link_type
            obj.id = data.link_value
            obj.pId = 'document'
          } else if (data.link_type === 'panorama') {
            obj.type = 'link'
            obj.link = '/' + data.link_type + '/h5'
            obj.query = { id: data.link_value }
          } else if (data.link_type === 'ceramic') {
            obj.type = 'link'
            obj.link = '/' + data.link_type
            obj.query = { uuid: data.link_value }
          } else if (data.link_type === 'video') {
            if (data.link_value && data.link_value !== '') {
              obj.type = 'info'
            }
            obj.id = data.link_value
          } else if (data.link_type === 'other') {
            obj.type = 'link'
            obj.link = data.link_value
          }

          this.link(obj, 'windowOpen')
        } else {
          console.log('无法跳转') // eslint-disable-line no-console
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.carousels {
  height: 690px;
  ::v-deep  .swiper-wrapper {
    height: 690px;
  }
  ::v-deep  .swiper-slide {
    height: 690px;
    // margin-right: 0 !important;
  }
  .carousels-img {
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  // 修改轮播图样式
  ::v-deep  .swiper-pagination {
    padding: 86px 15px 28px 0;
    left: auto;
    width: auto;
    bottom: 0;
    right: 0;
    -webkit-transform: translateX(0);
    transform: translateX(0);

    .swiper-pagination-bullet {
      width: 38px;
      height: 30px;
      border-radius: 0;
      background-image: url('../../../static/images/home/hooper.png');
      background-position: center;
      background-repeat: no-repeat;
      background-color: $c-transparent;
      margin: 0 20px;
      opacity: 1;
      &.swiper-pagination-bullet-active {
        background-image: url('../../../static/images/home/hooper-active.png');
        background-color: $c-transparent;
      }
    }
  }
  ::v-deep  .swiper-button-prev,
  ::v-deep  .swiper-button-next {
    width: 45px;
    height: 45px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: $c-transparent;
    svg {
      display: none;
    }
  }
  ::v-deep  .swiper-button-prev {
    background-image: url('../../../static/images/home/hooper-prev.png');
    margin-left: 20px;
  }
  ::v-deep  .swiper-button-next {
    background-image: url('../../../static/images/home/hooper-next.png');
    margin-right: 20px;
  }
  .hooper-font {
    box-sizing: border-box;
    height: 145px;
    background-color: $c-transparent-nav-list;
    padding: 30px 30px 0 44px;
    bottom: 0;
    left: 0;
    right: 0;
    line-height: 1;
    .hooper-font-title {
      font-size: 36px;
      color: $c-black;
      padding-bottom: 12px;
      overflow: hidden;
      -o-text-overflow: ellipsis; /* Opera 9-10 */
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .hooper-font-content {
      font-size: 18px;
      line-height: 1.3;
      color: $c-black;
      width: 60%;
      -o-text-overflow: ellipsis; /* Opera 9-10 */
      text-overflow: ellipsis;
      white-space: wrap;
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
// ::v-deep  .hooper {
//   width: auto;
// }
</style>
